import React, { useEffect, useState } from 'react';
import { Button, Typography, Box } from '@material-ui/core';
import { AddIcon } from '@material-ui/data-grid';
import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import useStyles from './Read.style';
import { Alert } from '@material-ui/lab';
import Cookies from 'universal-cookie';
import CustomNoRowsOverlay from '../../../components/CustomNoRowsOverlay';
import UserDataGrid from '../../../components/UserDataGrid';
import Visibility from '@material-ui/icons/Visibility';


const cookies = new Cookies();


const Read = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  const [providers, setProviders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const columns = [
    { field: 'fullName', headerName: t('common.substantive.name'), width: 230 },
    {
      field: 'id',
      headerName: ' ',
      renderCell: (params) => (
        <Button
          variant="contained"
          color="primary"
          size="small"
          component={Link}
          to={`/provider/provider/associate/${params.value}`}
          startIcon={<AddIcon />}
        >
          {t('common.substantive.patient')}
        </Button>
      ),
      width: 230,
      align: 'center'
    },
  ];

  useEffect(() => {
    const getProviders = async () => {
      try {
        let response = await fetch(`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_PROVIDER}`, {
          headers: {
            'X-ACCESS-TOKEN': cookies.get('token')
          }
        });
        let json = await response.json();
        if (!response.ok) {
          setError(json.message);
          return;
        };
        setProviders(json.map((provider, index) => {
          return {
            id: provider._id,
            fullName: `${provider.lastName}, ${provider.firstName}`,
          }
        }));
      } catch (error) {
        console.log(error);
        setError(`${t('module.provider.providerList.message.dataLoadError')}. ${t('common.message.error.seeLog')}.`);
      } finally {
        setLoading(false);
      };
    };

    getProviders();
  }, [t]);

  if (error) return <Alert severity="error">{error}</Alert>

  return (
    <div>
      <Box style={{ display: "flex", width: "100%", justifyContent: "space-between" }}>
        <Typography variant="h4" className={classes.title}>{t('module.provider.providerList.title')}</Typography>

        <Box>
          <Button
            variant="contained"
            color="primary"
            href="https://paptrack-prod.azurewebsites.net/provider/provider"
            startIcon={<Visibility />}
          >
            {t("common.form.button.PaptrakProviderview")}
          </Button>
        </Box>
      </Box>
      <UserDataGrid
        rows={providers}
        columns={columns}
        loading={loading}
        components={{
          noRowsOverlay: CustomNoRowsOverlay
        }}
      />
    </div>
  );
};

export default Read;